import fetch from "./fetch";
/**
 * 目标管理
 */
const targetManage = {
  //消息列表分页
  getMessagePage(params) {
    return fetch({
      isLoading: true,
      url: "/messageNotice/page",
      method: "GET",
      params,
    });
  },

  //发送通知
  sendMessage(id) {
    return fetch({
      isLoading: true,
      url: `/messageNotice/send?id=${id}`,
      method: "POST",
    });
  },

  //编辑消息
  updateMessage(data) {
    return fetch({
      isLoading: true,
      url: "/messageNotice/update",
      method: "POST",
      data,
    });
  },

  //新增消息
  createMessage(data) {
    return fetch({
      isLoading: true,
      url: "/messageNotice/save",
      method: "POST",
      data,
    });
  },

  //目标列表分页
  getTargetPage(params) {
    return fetch({
      isLoading: true,
      url: "/target/page",
      method: "GET",
      params,
    });
  },

  //编辑目标
  updateTarget(data) {
    return fetch({
      isLoading: true,
      url: "/target/update",
      method: "POST",
      data,
    });
  },

  //所有项目导入
  importTarget(data, projectId) {
    return fetch({
      isLoading: true,
      url: `/target/import?projectId=${projectId}`,
      method: "POST",
      hideError: true,
      data,
    });
  },

  //批量删除
  batchDelete(ids) {
    return fetch({
      isLoading: true,
      url: "/target/batchDelete",
      method: "POST",
      data: ids,
    });
  }
};

export default targetManage;
